import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ClipboardList, CheckCircle2, Clock } from "lucide-react";

export default function MyAssignments() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.listAssignments().then(setItems).catch(() => setItems([])); }, []);

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1F2937]">My Assignments</h1>
      <p className="mt-2 font-body text-[#6B7280]">Practice tasks from your teacher or parent.</p>
      {items === null ? (
        <div className="mt-10 text-center font-cursive text-2xl text-[#0D9488] animate-pulse">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-10 flex flex-col items-center rounded-3xl border border-dashed border-[#E5DECF] bg-white p-12 text-center">
          <ClipboardList size={40} color="#94A3B8" />
          <div className="mt-3 font-heading text-xl font-bold text-[#6B7280]">No assignments yet</div>
          <p className="mt-1 font-body text-[#94A3B8]">When your teacher assigns practice, it will show up here.</p>
        </div>
      ) : (
        <div className="mt-6 space-y-3">
          {items.map((a) => (
            <div key={a.id} data-testid={`assignment-${a.id}`} className="rounded-2xl border border-[#E5DECF] bg-white p-5">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <div className="font-heading text-lg font-bold text-[#1F2937]">{a.title}</div>
                  <div className="text-sm text-[#6B7280]">Assigned by {a.creator_name || a.creator_role}{a.due_date ? ` · due ${a.due_date}` : ""}</div>
                </div>
                {a.completed ? (
                  <span className="inline-flex items-center gap-1 rounded-full bg-[#10B981]/15 px-3 py-1 text-xs font-bold text-[#047857]"><CheckCircle2 size={14} /> Done</span>
                ) : (
                  <span className="inline-flex items-center gap-1 rounded-full bg-[#F59E0B]/15 px-3 py-1 text-xs font-bold text-[#B45309]"><Clock size={14} /> {a.progress?.done || 0}/{a.progress?.total || 0}</span>
                )}
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {(a.activity_ids || []).map((id) => (
                  <button key={id} onClick={() => navigate(`/activity/${id}`)} data-testid={`assignment-open-${id}`} className="rounded-xl bg-[#F2ECE1] px-3 py-1.5 text-sm font-bold text-[#1F2937] hover:bg-[#E5DECF]">Open activity</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
